import { API_BASE } from './config';

export { UPLOADS_BASE } from './config';

async function fetchJson(url) {
  const response = await fetch(url);
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  const data = await response.json();
  return data;
}

export const slugifyDoctorName = (text, id) => {
  const base = String(text || 'doctor')
    .toLowerCase()
    .replace(/^dr\.?\s*/i, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-');
  return base ? `${base}-${id}` : `doctor-${id}`;
};

export function getDoctorIdFromSlug(slug) {
  const raw = String(slug || '');
  if (/^\d+$/.test(raw)) return Number(raw);
  const match = raw.match(/-(\d+)$/);
  return match ? Number(match[1]) : null;
}

export async function fetchDoctors() {
  const data = await fetchJson(`${API_BASE}/master/doctors`);
  return Array.isArray(data) ? data : [];
}

export async function fetchDoctorById(id) {
  return fetchJson(`${API_BASE}/master/doctors/${id}`);
}

export async function fetchSpecialties() {
  const data = await fetchJson(`${API_BASE}/master/specialties`);
  return Array.isArray(data) ? data : [];
}

export async function fetchSpecializations() {
  const data = await fetchJson(`${API_BASE}/master/specializations`);
  return Array.isArray(data) ? data : [];
}

export async function fetchDegrees() {
  const data = await fetchJson(`${API_BASE}/master/degrees`);
  return Array.isArray(data) ? data : [];
}
